/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, Container } from '@material-ui/core';
import useSettings from 'src/hooks/useSettings';
import TableSearch from 'src/components/table/TableSearch';
import { CLIENTLIST_TABLE_HEAD } from 'src/constants/Dashboard';
import { useSnackbar } from 'notistack5';
import {
  filterClient,
  deleteClient,
  statusChange,
  resetClientMsg,
  resetCreateClientStatus
} from 'src/redux/slices/client';
import AlertDialog from 'src/components/common-components/AlertDialog';
import { useDispatch, useSelector } from 'src/redux/store';

ClientList.propTypes = {
  setEditId: PropTypes.func,
  setDeleteId: PropTypes.func,
  setClientListStatus: PropTypes.func,
  deleteId: PropTypes.string,
  clientList: PropTypes.array,
  clientListStatus: PropTypes.bool,
  loading: PropTypes.bool
};
export default function ClientList({
  setEditId,
  deleteId,
  setDeleteId,
  clientList,
  clientListStatus,
  setClientListStatus,
  loading
}) {
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  const [title, setTiltle] = useState('');
  const [content, setContent] = useState('');
  const dispatch = useDispatch();
  const { createClientStatus, clientMsg } = useSelector((state) => state.client);

  useEffect(() => {
    if (createClientStatus) {
      enqueueSnackbar('Client Disabled Successfully', { variant: 'success' });
      dispatch(resetCreateClientStatus());
    }
    if (clientMsg) {
      setClose(true);
      setOpen(true);
      dispatch(resetClientMsg());
      setTiltle('Disable Client');
      setContent(clientMsg);
    }
  }, [clientMsg, createClientStatus]);

  const handleClientListSwitch = (e) => {
    setClientListStatus(!e.target.checked);
  };

  const handleDelete = (id) => {
    setClose(false);
    setTiltle('Delete Client');
    setContent('Are you sure want to delete client data permanently??');
    setOpen(true);
    setDeleteId(id);
  };

  const handleDeleteDispatch = () => {
    dispatch(deleteClient(deleteId));
    enqueueSnackbar('Client Deleted Successfully', {
      variant: 'success'
    });
    setOpen(false);
  };

  const handleDisable = async (id) => {
    dispatch(statusChange(id, false));
  };

  const handleRestore = async (id) => {
    dispatch(statusChange(id, true));
    enqueueSnackbar('Client Restore Successfully', {
      variant: 'success'
    });
  };

  const handleEdit = (id) => {
    setEditId(id);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container maxWidth={themeStretch ? false : 'lg'} style={{ padding: 0 }}>
      <Card>
        <AlertDialog
          title={title}
          content={content}
          okFunction={close ? handleClose : handleDeleteDispatch}
          open={open}
          setOpen={setOpen}
        />
        <TableSearch
          tableHead={CLIENTLIST_TABLE_HEAD}
          tableData={clientList}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleDisable={handleDisable}
          handleRestore={handleRestore}
          status={clientListStatus}
          switchButton
          filterComponent={filterClient}
          switchButtonResponse={handleClientListSwitch}
          loading={loading}
        />
      </Card>
    </Container>
  );
}
